import baseAPI from '@/http'

const router = 'api/MunicipioResumoPerfil'

export const resumoMunicipioPerfilApi = {
    list: () => baseAPI.get(`${router}`),
}
